<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mb-3">
        <SGPFormInputComponent
          type="text"
          :name="'nome'"
          v-model="formulario.nome"
          :placeholder="'Nome do Tipo de Solicitação'"
          data-vv-as="Nome do Tipo de Solicitação"
          v-validate="'required|max:100'"
          :error="validationErrors.first('nome')"
        />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent
          name="descricao"
          type="textarea"
          rows="2"
          placeholder="Descrição"
          data-vv-as="Descrição"
          v-model="formulario.descricao"
          :error="validationErrors.first('descricao')"
        />
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioCtrlTipoSolicitacaoComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    ctrlTipoSolicitacao: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formulario: {
        id: this.ctrlTipoSolicitacao.id || null,
        nome: this.ctrlTipoSolicitacao.nome || '',
        descricao: this.ctrlTipoSolicitacao.descricao || '',
      }
    }
  },

  methods: {
    ...mapActions('ctrlTipoSolicitacao', ['salvarTipoSolicitacao', 'atualizarTipoSolicitacao']),

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      try {
        if (this.tipoFormulario === 'salvar') {
          await this.salvarTipoSolicitacao(this.formulario)
        } else {
          await this.atualizarTipoSolicitacao(this.formulario)
        }

        this.$emit('atualizarListagemTabela')
        this.limparCampos()
        this.fecharModal()
      } catch (error) {
        this.$toast.error('Erro ao salvar ou atualizar tipo de solicitação')
      }
    },

    limparCampos () {
      this.formulario = {
        nome: '',
        descricao: '',
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$emit('fechar')
    }
  }
}
</script>
